<template lang="pug">
.Finalize
  .Page
    .MeetingPage
      .d-flex.justify-content-between.align-items-center
        img(style="width: 28px; opacity: 0;" src="@/assets/kiosco46/arrow.svg")
      .mx-auto.max-width-box-form
        svg(width='32' height='32' viewbox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg').text-center.d-block.mx-auto.mt-5
          path(d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16345 24.8366 -6.26249e-07 16 -1.39876e-06C7.16345 -2.17128e-06 2.17128e-06 7.16344 1.39876e-06 16C0.00937525 24.8326 7.16733 31.9906 16 32Z' fill='#3290E0')
          path(d='M15.9987 24.9805C17.1446 24.9805 18.0117 24.3824 18.0117 23.4165L18.0117 14.5565C18.0117 13.5895 17.1448 12.9935 15.9987 12.9935C14.8807 12.9935 13.9856 13.6144 13.9856 14.5565L13.9856 23.4165C13.9857 24.3595 14.8807 24.9805 15.9987 24.9805ZM15.9987 10.9974C17.0997 10.9974 17.9957 10.1014 17.9957 8.99949C17.9957 7.8995 17.0997 7.00344 15.9987 7.00344C14.8977 7.00344 14.0026 7.8995 14.0026 8.99949C14.0027 10.1015 14.8977 10.9974 15.9987 10.9974Z' fill='#F4F4F4')
        h2.mt-3.Title.px-4.pb-3.text-center {{title}}
        .form-data.mb-3.mt-5.py-4.mx-1.px-4.mx-4
          p.mb-5.text-center.px-4.buttonText(style="line-height: 32px; font-size: 18.3521px;") Gracias por utilizar nuestros servicios. Te esperamos en una próxima ocasión.
          footer.ButtonFixed.text-center
            //- b-button(v-if="redirect" variant="whitecolmedica" @click="goHome()").buttonBack.blueButton Volver al menú inicial
            b-button(@click="goHome").buttonBack Ya puedes cerrar esta ventana
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Finalize",
  props: ["isFinalized"],
  computed: {
    title() {
      return this.isFinalized
        ? "Tu turno ha finalizado"
        : "Tu turno ha sido cancelado";
    }
  },
  methods: {
    ...mapActions({
      goToView: "mobileFSFB/goToView"
    }),

    goHome() {
      location.reload();
      this.goToView({ view: "Home" });
    }
  }
};
</script>

<style lang="scss" scoped>
.max-width-box-form {
  max-width: 523px;
}

.form-data {
  margin-top: 40px;
  background-color: #f9f9f9;
  filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1));
  border-radius: 21.4881px;
}

.buttonBack {
  font-weight: 500;
  font-size: 18.3521px;
  line-height: 27px;
  opacity: 1;
  background-color: #f4f4f4;
  color: gray;
  border: 2px solid gray;
}
</style>
